import { SLACK_SETTINGS_SECTION_ID } from "@intelligems/ig-types/dtos/slack-config";

export enum AnalyticsSubMenu {
  Overview = "dashboard/overview",
  Profit = "dashboard/profit",
  Revenue = "dashboard/revenue",
  Shipping = "dashboard/shipping",
  Visitors = "dashboard/visitors",
  Orders = "dashboard/orders",
  Discounts = "dashboard/discounts",
  ProductGroups = "dashboard/product-groups",
  Trend = "dashboard/trend",
  StatSig = "dashboard/statSig",
  Subscriptions = "dashboard/subscriptions",
  DataReconciliation = "dashboard/data-reconciliation",
}

export enum WidgetsSubMenu {
  Sitewide = "widget-library/sitewide",
  Campaign = "widget-library/experiences",
}

export const SettingsSectionId = {
  General: "general",
  Cogs: "cogs",
  Currency: "currency",
  Analytics: "analytics",
  Webhooks: "webhooks",
  CustomShipping: "custom-shipping",
  Billing: "billing",
  AgencyBilling: "agency-billing",
  ManageFunctions: "manage-functions",
  AtlasThemeAccess: "atlas-theme-access",
  PluginConfigurations: "plugin-configurations",
  ShopifyConfigurations: "shopify-configurations",
  DevTools: "dev-tools",
  Permissions: "permissions",
  UserPermissions: "user-permissions",
  SlackSettings: SLACK_SETTINGS_SECTION_ID,
} as const;

export interface BaseRoute {
  path: string;
  sidebarName: string;
  icon?: any;
  shortcut?: string;
  tooltipShortcut?: string;
}

export interface MainRoute extends BaseRoute {
  subRoutes?: BaseRoute[];
}
